import { matchPath } from 'react-router-dom';

import { ROUTE_LIST } from './manifest';
import type { RouteDescriptor } from './types';

const scoreRoutePath = (path: string): number => {
  const segments = path.split('/').filter(Boolean);
  return segments.reduce((score, segment) => {
    if (segment === '*') {
      return score;
    }
    if (segment.startsWith(':')) {
      return score + 2;
    }
    return score + 3;
  }, 0);
};

const sortedRoutes: RouteDescriptor[] = [...ROUTE_LIST].sort((a, b) => {
  const scoreDelta = scoreRoutePath(b.path) - scoreRoutePath(a.path);
  if (scoreDelta !== 0) {
    return scoreDelta;
  }
  return b.path.length - a.path.length;
});

export const findRouteByPathname = (
  pathname: string,
): RouteDescriptor | undefined => {
  for (const descriptor of sortedRoutes) {
    const match = matchPath(descriptor.path, pathname);
    if (match) {
      return descriptor;
    }
  }

  return undefined;
};
